import { render, staticRenderFns } from "./depreCiationInformation.vue?vue&type=template&id=6257e56b&scoped=true&"
import script from "./depreCiationInformation.vue?vue&type=script&lang=js&"
export * from "./depreCiationInformation.vue?vue&type=script&lang=js&"
import style0 from "./depreCiationInformation.vue?vue&type=style&index=0&id=6257e56b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6257e56b",
  null
  
)

export default component.exports